require ('./home');
var $cards ;
$(function() {
     $cards = $('.liste-cards').find('.grid').masonry({
        itemSelector: '.grid-item',
        gutter: 10,
        columnWidth: '.grid-sizer',
        isFitWidth: true
    });

    $cards.imagesLoaded().progress( function() {
        $cards.masonry('layout');
    });

    $('body').on('click', '.js-term .form-check-input', function () {
        $this = $(this);
        $term = $this.val();
        $parent_id = $('#parent_id').val();
        searchTerm($term,$parent_id);
    });
    $('body').on('change', '.js-term-change', function () {
        $this = $(this);
        $term = $this.val();
        $parent_id = $('#parent_id').val();
        searchTerm($term,$parent_id);
    });
});

function searchTerm(){
    /* pour afficher la liste des produits apres avoir utiliser les filtres */
    var masonryUpdate = function () {
        setTimeout(function () {
         
            $cards.masonry('destroy');
            $('#display-list').find('.grid').masonry(
                {
                    itemSelector: '.grid-item',
                    gutter: 10,
                    columnWidth: '.grid-sizer',
                    isFitWidth: true
                }
            );
        }, 0);
    }

    displayLoader(false);
    $.ajax({
        url: '/'+url_lang+'/ajax/search-term',
        type: 'POST',
        data: {'term': $term , 'parent_id':$parent_id},
        dataType: 'json',
        success: function (data) {
            if (data.views) {
                renderAjaxResponse(data);
            }
            masonryUpdate();
            displayLoader(true);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
    });
}

function renderAjaxResponse(data) {
    for (var htmlWrapper in data.views) {
        $('.' + htmlWrapper).replaceWith(data.views[htmlWrapper]);
    }
}